function serialize (obj) {
  return JSON.stringify(obj)
}

function deserialize (strVal, defaultVal) {
  if (!strVal) { return defaultVal }
  var val = ''
  try { val = JSON.parse(strVal) }
  catch(e) { val = strVal }
  return (val !== undefined ? val : defaultVal)
}

function read(key){  
  return localStorage.getItem(key)
}

function write(key, data) {
	return localStorage.setItem(key, data)
}

// function each(fn) {
// 	for (var i = localStorage.length - 1; i >= 0; i--) {
// 		var key = localStorage.key(i)
// 		fn(read(key), key)
// 	}
// }

function remove(key) {
	return localStorage.removeItem(key)
}

function clearAll() {
	return localStorage.clear()
}

const store = {
  get:function(key,optionalDefaultValue = ''){
    var data = read(key)
    return deserialize(data,optionalDefaultValue)
  },
  set:function(key,value){
    if (value === undefined) {
			return this.remove(key)
    }
    write(key,serialize(value));
  },
  remove:function(key){
    remove(key);
  },
  clear:function(){
    clearAll();
  },
  // each:function(callback){
  //   each(function(val, namespacedKey) {
	// 		callback.call(self, self._deserialize(val), (namespacedKey || '').replace(self._namespaceRegexp, ''))
	// 	})
  // }
}

export default store;